import { LocalStorageCapsule } from 'data-capsule';

export interface IStorage {
  setDomain: Function;
  setPPViewed: Function;
  getPPViewed: Function;
  setCycleSectionViewed: Function;
  getCycleSectionViewed(): Promise<any>;
  setOrderPageViewed(): Promise<any>;
  getOrderPageViewed(): Promise<any>;
}

export class Storage implements IStorage {
  namespace = 'com.wixpress.premium';
  domainItemKey = 'mpDomainStatic_DomainSearchGetPremiumModalData';
  packagePickerItemKey = 'packagePickerViewed';
  cycleSelectionItemKey = 'cycleSelectionViewed';
  orderPageItemKey = 'orderPageItemKey';

  scope: string | undefined;

  constructor(scope: string) {
    this.scope = scope;
  }

  public async setDomain(domainName) {
    if (this.scope) {
      const capsule = LocalStorageCapsule({
        namespace: this.namespace,
        scope: this.scope,
      });
      if (domainName) {
        await capsule.setItem(this.domainItemKey, { domainName });
      } else {
        await capsule.removeItem(this.domainItemKey);
      }
    }
  }

  public setPPViewed() {
    return this.setItemViewed(this.packagePickerItemKey);
  }

  public getPPViewed() {
    return this.getItemViewed(this.packagePickerItemKey);
  }

  public setCycleSectionViewed() {
    return this.setItemViewed(this.cycleSelectionItemKey);
  }

  public getCycleSectionViewed() {
    return this.getItemViewed(this.cycleSelectionItemKey);
  }

  public setOrderPageViewed() {
    return this.setItemViewed(this.orderPageItemKey);
  }

  public getOrderPageViewed() {
    return this.getItemViewed(this.orderPageItemKey);
  }

  private async setItemViewed(key) {
    if (this.scope) {
      const capsule = LocalStorageCapsule({
        namespace: this.namespace,
        scope: this.scope,
      });
      await capsule.setItem(key, true);
    }
  }

  private getItemViewed(key) {
    const capsule = LocalStorageCapsule({
      namespace: this.namespace,
      scope: this.scope,
    });
    try {
      return capsule.getItem(key);
    } catch {
      return Promise.reject();
    }
  }
}
